<template>
  <div v-if="authenticationService.entities.length > 0">
    <table class="table table-striped is-narrow">
      <thead>
        <tr>
          <th>{{'facility.inputs.entity'| translate}}</th>
          <th>{{'users.activities.activity'| translate}}</th>
          <th v-if="editable"></th>
        </tr>
      </thead>
      <tbody>
        <tr style="height:63px" v-for="(item, index) in filteredDataset" :key="index">
          <td width="30%" class="align-middle">
            <span>
              {{item.name}} {{item.cities && item.cities.length ? '(' + item.cities.join(', ') + ')' : ''}}&nbsp;
            </span>
          </td>
          <td :width="tdDynamicSize" class="align-middle">
            <div v-if="!isEditingActivity || editingRow !== index">
              <div v-if="item.activities.length > 0">
                <div v-if="item.activities.length > limitItems">
                  <va-popover
                    class="custom-tooltip-tag"
                    v-for="(item, index) in getFirstNItems(item.activities, limitItems)" :key="index"
                    :message="item.description"
                    placement="top">
                    <span class="tag-role">
                      {{$t(`activities.${item.id}`, item.name)}}
                    </span>
                  </va-popover>
                  <span @click="openAllRoles(item)" class="tag-role tag-role-clicable">
                    {{'users.roles.actions.show_more' | translate}} {{item.activities.length - limitItems}}..
                  </span>
                </div>
                <div v-else>
                  <va-popover
                    class="custom-tooltip-tag"
                    v-for="(item, index) in item.activities" :key="index"
                    :message="item.description"
                    placement="top">
                  <span class="tag-role">
                    {{$t(`activities.${item.id}`, item.name)}}
                  </span>
                </va-popover>
                </div>
              </div>
              <div v-else>
                {{ 'users.activities.without'|translate}}
              </div>
            </div>
            <div v-if="isEditingActivity && editingRow === index">
              <div class="form-group" style="margin-bottom:0rem;">
                <div class="input-group clearable-filter">
                  <multiselect
                    :options="availableActivities"
                    v-model="editingActivities"
                    track-by="id"
                    label="name"
                    select-label=""
                    deselect-label="×"
                    :placeholder="'users.roles.title' | translate"
                    :allow-empty="true"
                    :multiple="true"
                    :searchable="true"
                    :close-on-select="true"
                    :limit="limitItems">
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="editingActivities.length" @mousedown.prevent.stop="editingActivities = []"></div>
                    </template>
                    <template slot="tag" slot-scope="{ option }">
                      <span class="custom__tag">
                        <span>{{ $t(`activities.${option.id}`, option.name) }}&nbsp;</span>
                      </span>
                    </template>
                    <template slot="option" slot-scope="{option}">
                      <span>{{ $t(`activities.${option.id}`, option.name) }}&nbsp;</span>
                    </template>
                    <span slot="noResult">{{'patients.noResults'| translate}}</span>
                  </multiselect>
                </div>
              </div>
            </div>
          </td>
          <td v-if="editable" width="20%">
            <div class="d-flex justify-content-end">
              <a v-if="!isEditingActivity" href="#" @click.prevent="editUserEntityActivity(item, index)">
                  <i class="fa fa-pencil"></i>
              </a>
              <button @click.prevent="cancelEdit(item.id, index)" v-if="isEditingActivity && editingRow === index" class="btn btn-primary btn-micro btn-action-role">{{'users.roles.actions.cancel' | translate}}</button>&nbsp;
              <button @click.prevent="saveUserEntityRole(item)" v-if="isEditingActivity && editingRow === index" class="btn btn-primary btn-micro btn-action-role">{{'users.roles.actions.save' | translate}}</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import DynamicSizeMixin from '../../Helpers/DynamicSizeMixin'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
export default {
  props: {
    availableActivities: {
      type: Array,
      required: false,
      default: () => []
    },
    activities: {
      type: Array,
      required: true
    },
    query: {
      type: String,
      required: false,
      default: ''
    },
    limitItems: {
      type: Number,
      required: false,
      default: 3
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    Multiselect
  },
  data () {
    return {
      isEditingActivity: false,
      editingRow: -1,
      editingActivities: [],
      dataset: [],
      showFullRoles: false
    }
  },
  mixins: [
    DynamicSizeMixin,
  ],
  mounted () {
    this.generateDataset()
  },
  methods: {
    closeEntitiesByRoleModal: function () {
      this.showFullRoles = false
      this.entitiesForSelectedRole = []
    },
    openAllRoles: function (entity) {
      this.isEditingActivity = false
      this.showFullRoles = true
      this.$emit('showRolesForEntityModal', {
        roles: entity.roles,
        entity
      })
    },
    hasActivitiesToEdit: function (item) {
      return this.availableRolesByEntity(item.id).some(role => !role.$isDisabled)
    },
    generateDataset: function () {
      this.dataset = []
      this.authenticationService.entities.forEach(entity => {
        let index = this.dataset.findIndex(item => item.id === entity.id)
        if (index === -1) {
          this.dataset.push({
            id: entity.id,
            name: entity.name,
            cities: entity.cities,
            activities: []
          })
        }
      })

      // Para cada entidade do utilizador para qual está a editar
      this.activities.forEach(userActivity => {
        // Se encontrar um indice de entidade para esse utilizador adiciona as roles dessa entidade
        let index = this.dataset.findIndex(item => item.id === userActivity.entity.id)
        if (index >= 0) {
          this.dataset[index].activities.push({
            ...userActivity.activity
          })
        }
      })
      // Sort dataset
      this.dataset.sort((a, b) => {
        let entityNameA = a.name.toLowerCase()
        let entityNameB = b.name.toLowerCase()

        if (entityNameA < entityNameB) return -1
        if (entityNameA > entityNameB) return 1
        return 0
      })
    },
    editUserEntityActivity: function (userActivity, selectedRow) {
      if (selectedRow !== this.editingRow) {
        this.isEditingActivity = true
        this.editingRow = selectedRow
        this.editingActivities = JSON.parse(JSON.stringify(userActivity.activities))
      } else {
        this.isEditingActivity = !this.isEditingActivity
        this.editingRow = -1
      }
    },
    getFirstNItems: function (arr, n) {
      return arr.slice(0, n)
    },
    saveUserEntityRole: function (entity) {
      let userActivities = []
      entity.activities.forEach(activity => {
        userActivities.push({ entityId: entity.id, activityId: activity.id })
      })
      this.$emit('update-user-activities', userActivities)
      this.resetFields()
    },
    cancelEdit: function () {
      this.editingRow = -1
      this.isEditingActivity = false
    },
    resetFields: function () {
      this.editingRow = -1
      this.isEditingActivity = false
      this.editingActivities = []
      this.dataset = []
      this.generateDataset()
    }
  },
  computed: {
    ...mapGetters([
      'services'
    ]),
    filteredDataset: function () {
      if (this.query === '') return this.dataset
      return this.dataset.filter(item => {
        return item.name.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
      })
    },
    authenticationService: function () {
      return this.services.find(service => service.url === this.$store.state.evollauth_server)
    },
    authUserRoles: function () {
      return this.authenticationService.user_roles
    },
    authPermissions: function () {
      return this.authenticationService.user_permissions
    },
    authRolesPermissions: function () {
      return this.authPermissions.filter(p => p.info_type === 100)
    },
    authEntities: function () {
      return this.authenticationService.entities
    },
    authEntitiesRolesPermissions: function () {
      return this.authEntities.filter(e => {
        return this.authRolesPermissions.some(p => p.entity_id === e.id || p.entity_id === null)
      })
    }
  },
  watch: {
    filterByUnlocked: {
      handler (value) {
        this.generateDataset()
      }
    },
    roles: {
      handler () {
        this.generateDataset()
      },
      deep: true
    },
    query: debounce(function () {
      this.generateDataset()
    }, 500)
  }
}
</script>

<style lang="scss">
.tag-role{
  margin-right: 10px;
  padding: 0.4em 1em;
  background: #29c4a9;
  color: white;
  border-radius: 1em;
  font-weight: 100;
  font-size: 13px;
}

.custom-tooltip-tag{
  display: inline-block;
  margin-bottom: 0.5rem;
}

.multiselect .multiselect__tag {
    background-color: #29c4a9;
  }
  .multiselect .multiselect__option--highlight {
    background-color: #29c4a9;
  }

  .multiselect .multiselect__option--highlight::after {
    background-color: #29c4a9;
  }

  .multiselect .multiselect__option--selected {
    background-color: #d9d9d9;
  }

  .multiselect .multiselect__option--selected.multiselect__option--highlight {
    background-color: #e34a4a;
  }

  .multiselect .multiselect__option--selected.multiselect__option--highlight::after {
    background-color: #e34a4a;
  }

  .action-buttons-wrapper{
      margin-top: 10px;
  }

  .btn-action-role{
    padding: 0.6rem 1.45rem !important;
    letter-spacing: 1px !important;
    font-size: 9px !important;
  }

  .custom__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #29c4a9;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .custom__tag-icon {
    cursor: pointer;
    margin-left: 7px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 700;
    font-style: normal;
    width: 22px;
    text-align: center;
    line-height: 22px;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    border-radius: 5px;
  }

  .custom__tag-icon:focus, .custom__tag_removable-icon:hover {
    background: #21ab93;
  }

  .custom__tag-icon:after {
    content: "\D7";
    color: #266d4d;
    font-size: 14px;
  }

  .custom__tag-icon:focus:after, .custom__tag-icon:hover:after {
    color: #fff;
  }

  .without_remove_action{
    padding-right: 10px !important;
  }

  .multiselect__clear {
  position: absolute;
  right: 33px;
  height: 30px;
  width: 30px;
  display: block;
  cursor: pointer;
  z-index: 2;
}

.multiselect__clear:after, .multiselect__clear:before {
  content: "";
  display: block;
  position: absolute;
  width: 3px;
  height: 12px;
  background: #C0C0C0;
  top: 15px;
  right: 4px;
}

.multiselect__clear:after {
  transform: rotate(-45deg);
}

.multiselect__clear:before {
    transform: rotate(45deg);
}
</style>
